// This file can be replaced during build by using the `fileReplacements` array.
// `ng build -c prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { commonEnvironment } from "./environment.common";
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import "zone.js/plugins/zone-error";
import { CommonFeatureFlags, commonFeatureFlags } from "../../../common/constants/CommonFeatureFlags";

export const environment = {
    ...commonEnvironment,
    production: false,
    environment: "dev",
    redirectUrl: "https://jst.dev.findex.solutions",
    backendUrl: "https://uvi563xm5c.execute-api.ap-southeast-2.amazonaws.com/dev",
    locationsUrl: "https://dev.location.findex.dev",
    loggingLevel: commonEnvironment.loggingLevels.debug,
    notification: {
        endpoint: "wss://lysgysmpb5.execute-api.ap-southeast-2.amazonaws.com/dev",
        channel: "dev",
    },
    sentry: {
        ...commonEnvironment.sentry,
        enabled: false,
    },
    documentServiceUrl: "https://gdtln47049.execute-api.ap-southeast-2.amazonaws.com/dev",
    emailPreviewEndpoint: "https://r2lk10lf84.execute-api.ap-southeast-2.amazonaws.com/dev/email/preview",
    azureAD: {
        ...commonEnvironment.azureAD,
        clientID: "7eb3893a-1d84-4189-862f-cdb3594a066b",
    },
    taskx: "https://dev.taskx.findex.dev",
    crm: "https://qa2-familyoffice.cs151.force.com/s/",
    googleAnalytics: {
        id: "UA-114939185-14",
    },
    hotjar: {
        id: "2488553",
    },
    constants: {
        DEBOUNCE_TIME_MS: 500,
        WS_RECONNECT_INTERVAL: 2000,
        SALESFORCE_LINK_PREFIX: "https://qa2-familyoffice.cs151.force.com/s/opportunity/",
        SALESFORCE_LINK_SUFFIX: "",
    },
    featureFlags: {
        [CommonFeatureFlags.YEARLESS_SCOPES]: commonFeatureFlags.dev.yearlessScopes,
    },
};
